import { useMutation, useQuery } from '@tanstack/react-query'
import { getCategoryList, updateCategory, updateCategoryStatus, deleteCategory, addCategory, getSubCategoryList, updateSubCategory, updateSubCategoryStatus, deleteSubCategory, addSubCategory } from '../api/promptGroup'

// Category
export const useGetCategoryList = (queryParams = '') => {
    return useQuery({
        queryKey: ['prompt_category', queryParams],
        queryFn: () => getCategoryList(queryParams),
        enabled: !!queryParams
    });
};

export const useAddCategory = () => {
    return useMutation({
        mutationFn: addCategory
    })
};

export const useUpdateCategory = () => {
    return useMutation({
        mutationFn: updateCategory
    })
};

export const useUpdateCategoryStatus = () => {
    return useMutation({
        mutationFn: updateCategoryStatus
    })
};

export const useDeleteCategory = () => {
    return useMutation({
        mutationFn: deleteCategory
    })
};

// Sub Category
export const useGetSubCategoryList = (queryParams = '') => {
    return useQuery({
        queryKey: ['prompt_sub_category', queryParams],
        queryFn: () => getSubCategoryList(queryParams),
        enabled: !!queryParams
    });
};

export const useAddSubCategory = () => {
    return useMutation({
        mutationFn: addSubCategory
    })
};

export const useUpdateSubCategory = () => {
    return useMutation({
        mutationFn: updateSubCategory
    })
};

export const useUpdateSubCategoryStatus = () => {
    return useMutation({
        mutationFn: updateSubCategoryStatus
    })
};

export const useDeleteSubCategory = () => {
    return useMutation({
        mutationFn: deleteSubCategory
    })
};